module.exports = __webpack_public_path__ + "static/media/jungle-roller.44415eb3.jpg";